<style scoped>
    .label{
        display: inline-block;
        vertical-align: middle;
        width: 60px;
    }
</style>
<template>
    <div>
        <Drawer
            v-model="config.modal"
            width="640"
            title="招聘需求导出"
            >
            <div class="line">
                <span class="label">日期范围: </span>
                <DatePicker type="daterange" @on-change="daterangeChange" :options="date_option" placeholder="选择申请日期" style="width: 200px"></DatePicker>
            </div>
            <div class="line">
                <Button long
                    type="primary"
                    icon="md-download"
                    :loading="loading"
                    @click="exportResource"
                    >
                    导出
                </Button>
            </div>
        </Drawer>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                config: {
                    modal: false
                },
                loading: false,
                params: {
                    daterange: []
                },
                date_option: {
                    shortcuts: [
                        {
                            text: '最近一周',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                return [start, end];
                            }
                        },
                        {
                            text: '最近一个月',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                return [start, end];
                            }
                        },
                        {
                            text: '最近三个月',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                return [start, end];
                            }
                        },
                        {
                            text: '最近一年',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                                return [start, end];
                            }
                        }
                    ]
                }
            }
        },
        computed: {
            //
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            show(){
                this.config.modal = true;
            },
            daterangeChange(daterange){
                this.params.daterange = daterange;
            },
            checkValid(){
                if(this.params.daterange.length === 0){
                    this.$Message.error({title: '提示', content: '请选择日期'});
                    return false;
                }
                return true;
            },
            exportResource(){
                if(!this.checkValid()) return;
                if(this.loading) return;
                this.loading = true;
                Util.ajax.get(Util.api.export_recruit_need, {
                    params: this.params
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    console.log(res);
                    if(res.code === 1){
                        this.config.modal = false;
                        this.$emit("done");
                    }else{
                        this.$Modal.warning({title: '错误', content: res.msg});
                    }
                }).catch((e)=>{
                    console.log(e);
                    this.$Modal.warning({title: '错误', content: e.message});
                }).finally(()=>{
                    this.loading = false;
                });
            }
        }
    }
</script>
